import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import { TextOrderingUnit } from '../../../../models/GameStore';
import { TextOrderingGameMode } from '../../../Organisms';

import styles from './SpellingBlankUnit.module.css';

type SpellingBlankUnitProps = {
  unit: TextOrderingUnit;
  isAnswered: boolean;
  isHighlighted: boolean;
  hintIndex: number;
  color?: string;
  globalBlankIndex: number;
  blankRefs: React.MutableRefObject<(HTMLDivElement | null)[]>;
  variant?: TextOrderingGameMode.Syllable | TextOrderingGameMode.Spelling;
  isPreFilled: boolean;
  isLearner: boolean;
};

enum AnswerState {
  notAnswered,
  FullReveal,
  LearnerFullReveal,
}

export const SpellingBlankUnit: React.FC<SpellingBlankUnitProps> = ({
  unit,
  isAnswered,
  isHighlighted,
  color,
  globalBlankIndex,
  blankRefs,
  variant = TextOrderingGameMode.Spelling,
  isPreFilled,
  isLearner,
}) => {
  const [answerState, setAnswerState] = useState<AnswerState>(
    AnswerState.notAnswered,
  );

  useEffect(() => {
    if (isAnswered && isLearner) {
      setAnswerState(AnswerState.LearnerFullReveal);
    } else if (isAnswered) {
      setAnswerState(AnswerState.FullReveal);
    } else {
      setAnswerState(AnswerState.notAnswered);
    }
  }, [isAnswered, isLearner]);

  const handleAnimationComplete = () => {
    // onCompleted();
  };
  return (
    <div
      ref={(el) => (blankRefs.current[globalBlankIndex] = el)}
      className={styles.blankContainer}
    >
      {answerState === AnswerState.FullReveal ? (
        // TODO: animation
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, type: 'spring', stiffness: 100 }}
          className={styles.text}
          style={{ color }}
          onAnimationComplete={handleAnimationComplete}
        >
          {unit.key}
        </motion.span>
      ) : answerState === AnswerState.LearnerFullReveal ? (
        <span
          className={`${styles.grayBlock}`}
          // style={{
          //   width:
          //     variant === TextOrderingGameMode.Syllable ? '4rem' : '1.5rem',
          // }}
        >
          {unit.key}
        </span>
      ) : isPreFilled && variant === TextOrderingGameMode.Spelling ? (
        <span
          className={`${styles.grayBlock}`}
          // style={{
          //   width: '1.5rem',
          // }}
        >
          {unit.key}
        </span>
      ) : (
        <span
          className={`${styles.grayBlock} ${styles.grayBlockChar} ${
            isHighlighted ? styles.fade : ''
          }`}
          // style={{
          //   width:
          //     variant === TextOrderingGameMode.Syllable ? '4rem' : '1.5rem',
          // }}
        >
          {unit.key}
        </span>
      )}
    </div>
  );
};
